import { Component, OnInit } from '@angular/core';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';

const SUBTOTAL_LABELS: Record<number, string> = {
    1: 'Total Cars for the Business Group :',
    2: 'Total Cars for the Master Origin :',
};

@Component({
    selector: 'lib-transit-time-trip-cycle-summary',
    templateUrl: './transit-time-trip-cycle-summary.component.html',
    styleUrl: './transit-time-trip-cycle-summary.component.css',
})
export class TransitTimeTripCycleSummaryComponent implements OnInit {
    public gridId = 129;
    public gridSource: any;
    public displayReport = false;
    public controlNames: string[] = ['Start Date', 'End Date'];

    constructor(public reportService: RailtracReportsService, public pageService: PageService) {}

    ngOnInit(): void {
        this.pageService.setHeader('Transit Time - Trip Cycle Summary Report');
    }

    onGetReportClick(event: any): void {
        this.displayReport = true;
        this.gridSource = this.reportService.CreateAspNetDatastore(
            ReportConstants.ReportDataApiCall,
            this.gridId.toString(),
            event.startDate,
            event.endDate,
        );
    }

    onCancelClick(): void {
        this.displayReport = false;
    }

    onCellPrepared(e: any): void {
        if (e.rowType !== 'data' || !e.cellElement) {
            return;
        }

        const label = SUBTOTAL_LABELS[e.data?.row_type];
        if (!label) {
            return;
        }

        const el = e.cellElement as HTMLElement;

        if (e.data.row_type === 1) {
            const nextRow = e.component?.getVisibleRows?.()?.[e.rowIndex + 1];
            if (nextRow?.data?.row_type === 2) {
                el.classList.add('rt-subtotal-merge');
            }
        }

        switch (e.column?.dataField) {
            case 'no_of_cars':
                el.classList.add('rt-subtotal-value');
                break;
            case 'fleet_id':
                el.textContent = label;
                el.classList.add('rt-subtotal-label');
                break;
            default:
                el.textContent = '';
        }
    }
}
